module.exports = __webpack_public_path__ + "static/logo-199ae92126c83cc1ee8946fbd572bc1e.svg";